window.app_models.properties = {
    "active":[
        window.app_models.property
    ],
    "possible":[
        window.app_models.property
    ],
    "rejected":[
        window.app_models.property
    ],
    "moved_out":[
        window.app_models.property
    ],
    "in_process":[
        window.app_models.property
    ]
};


// WEBPACK FOOTER //
// ./resources/assets/js/models/properties.js